import {Injectable} from '@angular/core';
import {BaseService} from './services/base-service';
import {HttpClient} from '@angular/common/http';
import {ApiService} from './services/api.service';
import {UserService} from './services/user.service';
import {Observable} from 'rxjs/Observable';
import {constants} from './shared/constants/constants';
import {catchError, flatMap} from 'rxjs/operators';
import {of, throwError} from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class ConfigurationService extends BaseService {

    constructor(protected http: HttpClient,
                protected auth: ApiService,
                protected user: UserService) {
        super(http, auth, user);
    }

    destroy(): void {
        super.destroy();
    }

    getStoredUserSettings(): Observable<any> {
        const url = this.API_BASE_URL + constants.api.routes.configuration.dashboard;
        return this.http.get(
            url, {headers: this.getDefaultHeaders(this.auth.getToken())}
        ).pipe(
            flatMap((res: { status: string, data: any }) => {
                return of(this.mapDefault(res));
            }),
            flatMap((mapped: string) => {
                let parsed = null;
                try {
                    parsed = JSON.parse(mapped);
                } catch (e) {
                    return throwError({msg: 'Error parsing expected string resource', e});
                }

                if (this.validateParsedStorageObject(parsed)) {
                    return of(parsed);
                }
                return throwError({msg: 'Error on validating the parsed string storage'});
            }),
            catchError(error => this.handleError(error))
        );
    }

    private validateParsedStorageObject(obj: any) {
        if ('power_checker' in obj) {
            const name = 'name' in obj.power_checker;
            const room = 'room' in obj.power_checker;
            return name && room;
        }
        return false;
    }
}
